var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isGroup
    ? _c(
        "MapButton",
        _vm._g(
          _vm._b(
            {
              attrs: {
                active: _vm.active,
                elevation: "0",
                fab: "",
                height: _vm.groupSize,
                text: "",
                title: _vm.tooltip || _vm.title,
                width: _vm.groupSize,
                disabled: _vm.disabled,
              },
            },
            "MapButton",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm._t("default", function () {
            return [_c("MapIcon", [_vm._v(" " + _vm._s(_vm.icon) + " ")])]
          }),
        ],
        2
      )
    : _c("div", { staticClass: "button-container" }, [
        _c(
          "div",
          { attrs: { title: _vm.tooltip || _vm.title } },
          [
            _vm._t("content", function () {
              return [
                _c(
                  "MapButton",
                  _vm._g(
                    _vm._b(
                      {
                        attrs: {
                          height: _vm.size,
                          loading: _vm.loading,
                          width: _vm.size,
                          disabled: _vm.disabled,
                        },
                      },
                      "MapButton",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  ),
                  [
                    _vm._t("default", function () {
                      return [
                        _c("MapIcon", [_vm._v(" " + _vm._s(_vm.icon) + " ")]),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            }),
          ],
          2
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }